import { useRef, useState } from "react";
import { IconSvg } from "../../../../../../../../../../utils/constants/icons/iconSvg.constant";
import { CustomSelect } from "../../../../../../../../../../components/ui/CustomSelect/CustomSelect";
import { Button } from "../../../../../../../../../../components/ui/Buttons/Button/Button";
import { CustomInput } from "../../../../../../../../../../components/ui/CustomInput/CustomInput";
import { getCountryFlag } from "../../../../../../../../../../utils/helpers/getCountryFlag";
import { classNames } from "../../../../../../../../../../utils/helpers/classNames";
import "./ProxyItem.scss";
import { useTranslation } from "../../../../../../../../../../hooks";

export const ProxyItem = () => {
  const contentRef = useRef(null);
  const [isItemOpen, setIsItemOpen] = useState(false);
  const [height, setHeight] = useState(0);

  const { cabinet: { orders: { residential: {
    creationDate, authorization,
    login, password, geo, isp,
    ports, exportFormat, typeLink,
    rotationMethod, apply, options
  } } } } = useTranslation();

  const itemHandler = () => {
    if (!isItemOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }

    setIsItemOpen((current) => !current);
  };

  return (
    <li className={classNames("proxy-item", { "proxy-item--open": isItemOpen })}>
      <div className="proxy-item__head">
        <div className="proxy-item__name-container" onClick={itemHandler}>
          <div className="proxy-item__name">List 1</div>
          <IconSvg tag="newArrow" />
        </div>
        <div className="proxy-item__actions">
          <div className="proxy-item__action proxy-item__download-icon">
            <IconSvg tag="download"/>
          </div>
          <div className="proxy-item__action proxy-item__trash-icon">
            <IconSvg tag="newTrash"/>
          </div>
        </div>
      </div>
      <div ref={contentRef} style={{ height }} className={classNames("proxy-item__content", { "proxy-item__content--open": isItemOpen })}>
        <div className="proxy-item__divider"></div>
        <div className="proxy-item__info">
          <div>
            <div className="general__rotation-label-wrapper">
              <div className="general__label">{rotationMethod}</div>
              <IconSvg tag="newInfo"/>
            </div>
            <div className="proxy-item__rotation-container">
              <CustomSelect/>
              <Button tab="confirm">{apply}</Button>
            </div>
          </div>
          <div>
            <div className="general__label">{creationDate}:</div>
            <div className="proxy-item__date">Sep 22, 2024 <span>14:35</span></div>
          </div>
          <div className="proxy-item__auth">
            <div className="general__label">{authorization}:</div>
            <div className="proxy-item__input-container">
              <div className="proxy-item__input-label">{login}:</div>
              <CustomInput value="User128"/>
            </div>
            <div className="proxy-item__input-container">
              <div className="proxy-item__input-label">{password}:</div>
              <CustomInput value="178RTjiey64747859"/>
            </div>
          </div>
        </div>
        <div className="proxy-item__options">
          <div className="proxy-item__text">{options}:</div>
          <div className="proxy-item__options-container">
            <div className="proxy-item__geo">
              <div className="general__label">{geo}:</div>
              <div className="proxy-item__country-container">
                {getCountryFlag("USA")}
                <div className="proxy-item__text">USA, Pittsburgh, PA</div>
              </div>
            </div>
            <div className="proxy-item__isp">
              <div className="general__label">{isp}:</div>
              <div className="proxy-item__text">Broadband</div>
            </div>
            <div className="proxy-item__ports">
              <div className="general__label">{ports}:</div>
              <div className="proxy-item__text">10</div>
            </div>
            <div className="proxy-item__export">
              <div className="general__label">{exportFormat}:</div>
              <div className="proxy-item__text">{typeLink}</div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};
